import React, {useState} from "react";
import {useFormContext} from "react-hook-form";
import {useSelector} from "react-redux";
import toast from "react-hot-toast";
import Button from "@/components/common/Button";
import {currencyFormat} from "@/utils";
import {ReactComponent as RiEditLine} from "@/assets/icons/ri-edit-line.svg";
import {
  ReactComponent as RiRestartLine
} from "@/assets/icons/ri-restart-line.svg";
import {RootState, useAppDispatch} from "@/store";
import Input from "@/components/common/Input";
import {createRefund, updateRefund} from "@/store/refund-detail/action";

const ModalFooter = () => {
  const dispatch = useAppDispatch()
  const {watch, getValues, setValue}
    = useFormContext()
  const {refund, modal}
    = useSelector((rootState: RootState) => rootState.refundDetail.state)
  const {currentId} = modal
  const calculatePrice = (currDetails = getValues('details')) => {
    if (currentId) {
      setValue('total_price', refund?.total_price ?? 0)
      return
    }

    const totalPrice = currDetails.reduce((acc, curr: RefundDetail) => acc + curr.price, 0)
    setValue('total_price', totalPrice)
  }
  const [showEditPrice, setShowEditPrice] = useState(false)
  const {detail} = useSelector((rootState: RootState) => rootState.invoice.state)

  const validateRefund = () => {
    let errorMessage = ''

    const refundData = getValues() as Refund
    const preliminaryCheck = refundData.details.length > 0 &&
      refundData.total_price > 0 &&
      refundData.note
    const bankInfoCheck = refundData.is_manual_input
      ? refundData.customer_info.bank_code &&
      refundData.customer_info.account_name &&
      refundData.customer_info.account_number
      : true

    if (refundData.details.length <= 0) {
      errorMessage = 'Must select at least 1 invoice detail'
    } else if (refundData.total_price <= 0) {
      errorMessage = 'Total refund can not be 0'
    } else if (!refundData.note) {
      errorMessage = 'Refund notes must be filled'
    } else if (!bankInfoCheck) {
      errorMessage = 'Customer bank info is not complete'
    }

    if (errorMessage) {
      toast.error(errorMessage)
    }

    return preliminaryCheck && bankInfoCheck
  }

  const constructPayload = () => {
    const payload = {
      ...getValues(),
      customer_id: detail?.customer_id,
      subscription_id: detail?.subscription_id,
      venue_id: detail?.venue_id,
      total_price: parseInt(getValues("total_price"), 10)
    } as Refund
    if (!payload.is_manual_input && !currentId) {
      payload.customer_info = null
    }
    return payload
  }

  const handleSubmit = () => {
    if (!validateRefund()) {
      return
    }
    if (currentId) {
      dispatch(updateRefund({
        id: currentId,
        ...constructPayload()
      }))
      return
    }
    dispatch(createRefund({
      ...constructPayload()
    }))
  }
  const handleClickEditPrice = () => {
    setShowEditPrice(true)
  }
  const handleClickResetPrice = () => {
    setShowEditPrice(false)
    calculatePrice()
  }

  return <div className="j-row justify-center items-center py-4 px-8 gap-5">
    <div className="j-col flex-grow">
      <div className="text-jxs text-grey-dark">Partially Refund</div>
      <div className="text-jxs font-medium">Total Refund Amount</div>
    </div>
    {
      showEditPrice
        ? <div
          className="flex flex-row items-center justify-center gap-2 text-jsm font-bold text-red-primary whitespace-nowrap">
          <div className="custom-input w-[150px]">
            <div className="custom-input-left text-black-primary">Rp</div>
            <Input
              className="rounded-r text-black-primary"
              expanded
              name="total_price"
              type="number"
            />
          </div>
          <div className="vertical-separator"/>
          <div
            aria-hidden
            role="button"
            className="text-black-primary"
            onClick={handleClickResetPrice}>
            <RiRestartLine/>
          </div>
        </div>
        : <div
          className="flex flex-row items-center justify-center gap-2 text-jsm font-bold text-red-primary whitespace-nowrap">
          <div>
            {currencyFormat(watch('total_price'))}
          </div>
          <div className="vertical-separator"/>
          <div
            aria-hidden
            role="button"
            className="text-black-primary"
            onClick={handleClickEditPrice}>
            <RiEditLine/>
          </div>
        </div>
    }
    <div>
      <Button
        onClick={handleSubmit}
        type={null}
        variant="primary"
        className="border-stroke-subtle border px-4"
      >
        <div className="flex gap-2 justify-center items-center h-4">
          {currentId ? 'Update' : 'Add'}
        </div>
      </Button>
    </div>
  </div>
}

export default ModalFooter;